<template>
  <v-container>
    <v-container>
      <v-card>
        <v-toolbar flat color="grey lighten-2">Details</v-toolbar>
        <v-row no-gutters>
          <v-col cols="5">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>
                    <span style="color:grey">Showcase Id</span>
                  </td>
                  <td>{{ showcase.showcaseId || '-' }}</td>
                </tr>
                <tr>
                  <td><span style="color:grey">Name</span></td>
                  <td>{{ showcase.name || '-' }}</td>
                </tr>
                <tr>
                  <td><span style="color:grey">Domain</span></td>
                  <td>{{ showcase.domain || '-' }}</td>
                </tr>
                <tr>
                  <td><span style="color:grey">Hosted Zone</span></td>
                  <td>{{ showcase.hostedZone || '-' }}</td>
                </tr>
                <tr>
                  <td><span style="color:grey">Multiple Environments</span></td>
                  <td>{{ showcase.multiEnv || '-' }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-col cols="5">
            <v-simple-table>
              <tbody>
                <tr>
                  <td><span style="color:grey">Image Name</span></td>
                  <td>{{ showcase.imageName || '-' }}</td>
                </tr>
                <tr>
                  <td><span style="color:grey">TTPS Version</span></td>
                  <td>{{ showcase.ttpsVersion || '-' }}</td>
                </tr>
                <tr>
                  <td><span style="color:grey">Description</span></td>
                  <td>{{ showcase.description || '-' }}</td>
                </tr>
                <tr>
                  <td><span style="color:grey">Status</span></td>
                  <td>{{ showcase.status || '-' }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container>
      <v-card>
        <v-toolbar flat color="grey lighten-2">Applications</v-toolbar>
        <v-simple-table>
          <tbody>
            <tr>
              <td>
                <span style="color:grey">Workbench</span>
              </td>
              <td>
                <a :href="workbenchUrl" target="_blank"
                  >{{ workbenchUrl }}/workbench</a
                >
              </td>
            </tr>

            <tr>
              <td>
                <span style="color:grey">Publisher</span>
              </td>
              <td>
                <a :href="publisherUrl" target="_blank"
                  >{{ publisherUrl }}/publisher</a
                >
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'ShowcaseInformation',
  props: ['showcase'],
  data: () => ({}),
  computed: {
    publisherUrl() {
      return `https://${this.showcase.domain}.${this.showcase.hostedZone}/publisher`
    },
    workbenchUrl() {
      return `https://${this.showcase.domain}.${this.showcase.hostedZone}/workbench`
    }
  }
}
</script>

<style scoped></style>
